/* eslint-disable react/prop-types */
import { Card, CardBody, Col, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import OrderDetailSummary from './Summary';
import TableContainer from '../../../../Components/Common/TableContainer';
import { formatCurrency } from '../../../../helpers/format';

export const strategyCashbackOriginEnum = {
  item: 'Estratégia de catálogo',
  my_offer: 'Minha Oferta',
  strategy: 'Estratégia de conta',
  minimum_accumulation: 'Valor mínimo de geração',
  maximum_accumulation: 'Valor máximo de geração',
  minimum_sales_value_not_reached: 'Valor da venda abaixo do mínimo',
};

const formatItemStrategyName = (item) => {
  const origin = strategyCashbackOriginEnum[item?.itemCashback?.accumulationOrigin];

  const cashbackValue =
    item?.itemCashback?.accumulationType === 'percentage'
      ? `${Math.round(Number(item?.itemCashback?.accumulationBaseValue) * 100)}%`
      : formatCurrency(item?.itemCashback?.accumulationBaseValue);

  return origin ? `${origin} - ${cashbackValue}` : '-';
};

const OrderDetailTable = (props) => {
  const { order_items, isLoading } = useSelector(
    createSelector(
      (store) => store.Order,
      ({ order, isLoading }) => {
        const processedItems = order?.items || [];

        return {
          order_items: processedItems,
          isLoading,
        };
      },
    ),
  );

  const columns = [
    {
      Header: props.t('order-details.data-table.product-details'),
      Cell: ({ row }) => {
        const data = row?.original;
        const code = props.t('order-details.data-table.product-code');
        const desc = props.t('order-details.data-table.product-description');

        return (
          <div className="d-flex flex-column">
            <div className="d-flex gap-1">
              <span className="fw-semibold">{code}:</span>
              <span>{data.identifier}</span>
            </div>

            <div className="d-flex gap-1">
              <span className="fw-semibold">{desc}:</span>
              <span>{data.description}</span>
            </div>
          </div>
        );
      },
    },

    {
      Header: props.t('order-details.data-table.product-price'),
      Cell: (props) => {
        const data = props?.row?.original;
        return formatCurrency(data.unitPrice ?? 0);
      },
    },
    {
      Header: props.t('order-details.data-table.assigned-strategy'),
      Cell: (props) => {
        const data = props?.row?.original;
        return formatItemStrategyName(data);
      },
    },

    {
      Header: props.t('order-details.data-table.product-amount'),
      Cell: (props) => props?.row?.original?.quantity,
    },

    {
      Header: props.t('order-details.data-table.product-discount'),
      Cell: (props) => {
        const data = props?.row?.original;
        return formatCurrency(data?.totalDiscount ?? 0);
      },
    },

    {
      Header: props.t('order-details.data-table.product-generated'),
      Cell: (props) => {
        const data = props?.row?.original;
        return formatCurrency(data.generatedCashback ?? 0);
      },
    },

    {
      Header: props.t('order-details.data-table.product-total'),
      Cell: (props) => {
        const data = props?.row?.original;
        const value = (data.totalPrice ?? 0) - (data.totalDiscount ?? 0);
        return formatCurrency(value);
      },
    },
  ];

  return (
    <Row>
      <Col>
        <span className="fs-4 fw-semibold">{props.t('finish-order-details')}</span>

        {isLoading ? (
          <div className="skeleton card" style={{ height: '250px' }} />
        ) : (
          <Card className="mt-1">
            <CardBody className="p-1 pb-0 text-muted">
              <TableContainer
                isLoading={isLoading}
                data={order_items ?? []}
                columns={columns}
                activePage={1}
                setPage={() => {}}
                pageSize={10}
                totalPages={0}
                count={0}
                className="custom-header-css"
                divClass="table-responsive mt-auto"
                tableClass="align-middle table-nowrap m-0"
                theadClass="table-light"
              />

              <OrderDetailSummary />
            </CardBody>
          </Card>
        )}
      </Col>
    </Row>
  );
};

export default withTranslation()(OrderDetailTable);
